import { Pipe, PipeTransform } from '@angular/core';
import { FeeChargeRow } from '../../models/fee-config';

const SCHEDULE_FIELDS: (keyof FeeChargeRow)[] = [
  'eventType', 'eventSubValue', 'monthlyCustomDay',
  'q1Month', 'q2Month', 'q3Month', 'q4Month',
  'h1Month', 'h2Month',
];

@Pipe({ name: 'feeEventScheduleChanged', pure: true })
export class FeeEventScheduleChangedPipe implements PipeTransform {
  transform(currentRow: FeeChargeRow, oldRow: FeeChargeRow | undefined): boolean {
    if (!oldRow) return false;
    return SCHEDULE_FIELDS.some(field => currentRow[field] !== oldRow[field]);
  }
}
